import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";

type Props = {
  cities: string[];
};

const OwnerSearchForm: React.FC<Props> = ({ cities }) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [filters, setFilters] = useState({
    name: searchParams.get("name") || "",
    phone: searchParams.get("phone") || "",
    email: searchParams.get("email") || "",
    city: searchParams.get("city") || "",
  });


  // Fetch categories
  // Fetch subCategories based on selected typ
  // Update filters state
  const handleChange = (key: string, value: string) => {
    setFilters(prev => ({
      ...prev,
      [key]: value,
      ...(key === "type" ? { subType: "" } : {})
    }));
  };

  // Submit search params
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const newParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value) newParams.set(key, value);
    });
    if (newParams.toString()) newParams.set("page", "1");
    setSearchParams(newParams);
  };

  // Clear param immediately if empty
  useEffect(() => {
    const newParams = new URLSearchParams(searchParams.toString());
    Object.entries(filters).forEach(([key, value]) => {
      if (!value && newParams.has(key)) {
        newParams.delete(key);
      }
    });
    setSearchParams(newParams);
  }, [filters, searchParams, setSearchParams]);

  return (
    <form onSubmit={handleSubmit} className="flex flex-wrap gap-5">
      <input
        type="text"
        placeholder={t("search_by_name")}
        value={filters.name}
        onChange={e => handleChange("name", e.target.value)}
        className="border rounded-lg px-3 py-2 w-[265px] focus:outline-none focus:ring-2 focus:ring-primary"
      />
      <input
        type="text"
        placeholder={t("search_by_phone")}
        value={filters.phone}
        onChange={e => handleChange("phone", e.target.value)}
        className="border rounded-lg px-3 py-2 w-[265px] focus:outline-none focus:ring-2 focus:ring-primary"
      />
      <input
        type="text"
        placeholder={t("email")}
        value={filters.email}
        onChange={e => handleChange("email", e.target.value)}
        className="border rounded-lg px-3 py-2 w-[265px] focus:outline-none focus:ring-2 focus:ring-primary"
      />
      <select
        value={filters.city}
        onChange={e => handleChange("city", e.target.value)}
        className="border rounded-lg px-3 py-2 w-[265px] focus:outline-none focus:ring-2 focus:ring-primary"
      >
        <option value="">{t("search_by_city")}</option>
        {cities.map((city, idx) => (
          <option key={idx} value={city}>
            {city}
          </option>
        ))}
      </select>



      <button
        type="submit"
        className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-primary/80 transition"
      >
        <Search />
      </button>
    </form>
  );
};

export default OwnerSearchForm;
